import Dropdown from "components/DropDown"
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import Button from "../../../../components/Button"
import InputField from "../../../../components/InputField"
import { addNewTax, getCenterDetails, getTaxCatalogDetails } from "../../../../core/services/api"
import "./AddNewTax.scss"

function AddNewTax({ onCancel, editValues, editData }: any) {
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  console.log("child component", editData)
  const [isSubmit, setIsSubmit] = useState(false)
  const [resData, setResData] = useState([])
  const [formErrors, setFormErrors] = useState<any>()
  // const editData = location?.state?.editData
  const [currentData, setCurrentData] = useState<any>()

  const [taxCatalogInfo, setTaxCatalogInfo] = useState<any>({
    name: "",
    percentage: ""
  })
  const handleSubmit = (e: any) => {
    e.preventDefault()
    setFormErrors(validate(taxCatalogInfo))
    setIsSubmit(true)
  }


  const validate = (values: any) => {
    const errors: any = {}
    if (!values.name) {
      errors["name"] = "Name is required"
    }

    return errors
  }
  useEffect(() => {
    getTaxCatalogDetails(userDetail?.currentCenter?.centerId)
      .then((res) => {
        setCurrentData(res)
        console.log("res", res)
      })
      .catch((err) => {
        console.log('err', err)
      })
    if (editData) {
      setTaxCatalogInfo({
        name: editData.name,
        percentage: editData.percentage
      })
    }
  }, [])

  useEffect(() => {
    if (formErrors && Object.keys(formErrors).length === 0 && isSubmit) {
      let taxCatalogDetails = {
        name: taxCatalogInfo.name,
        percentage: parseInt(taxCatalogInfo.percentage),
      }

      console.log("editdata", editData)
      let finalReq = [];
      if (Object.keys(editData).length > 0) {
        console.log("inside if", taxCatalogDetails)

        const find = currentData?.findIndex((eachData: any) => eachData.id === editData?.id);

        let clone = [...currentData]
        clone[find] = taxCatalogDetails;

        finalReq = clone
      }

      else {
        console.log("inside else", taxCatalogDetails)
        finalReq = currentData.concat(taxCatalogDetails)

      }
      console.log("finalReq", finalReq)

      addNewTax(centerId, finalReq)
        .then((data) => {
          setResData(data)
          onCancel()
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [formErrors])

  const [centerDetail, setCenterDetail] = useState<any>()
  useEffect(() => {
    getCenterDetails().then((res: any) => {
      setCenterDetail(res);
    }).catch((err: any) => {
      console.log(err, "error")
    })

  }, [])

  const [centerId, setCenterId] = useState<any>()
  const dropdownCenters = centerDetail?.map((val: any) => {
    return {
      label: val?.centerName,
      value: val?.id
    }
  })
  return (
    <div className="add-new-tax-container">

      <div className="add-new-tax-details">
        <form onSubmit={handleSubmit}>
          <div className="add-new-tax-heading" style={{ display: 'flex', alignItems: 'center' }}>
            <div
              className="billing-back-image"
              onClick={() => {
                onCancel(true)
              }}
            >
              <img
                src={'../../../assets/images/back-icon.svg'}
                height={'60px'}
                width={'60px'}
                alt="back button"
              />
            </div>

            Add New Tax</div>
          <div className="row nameDetails">
            <div className="col-1">
              <label className="textlabel">Tax Name:</label>
            </div>

            <div className="col-3">
              <InputField
                placeholder="Name"
                value={taxCatalogInfo?.name}
                handleChange={(e) =>
                  setTaxCatalogInfo({
                    ...taxCatalogInfo,
                    name: e.target.value,
                  })
                }
                errorMsg={formErrors?.name}
              />
            </div>
          </div>
          <div className="row nameDetails">
            <div className="col-1">
              <label className="textlabel">Tax Value:</label>
            </div>
            <div className="col-3">
              <InputField
                placeholder="Tax value"
                value={taxCatalogInfo.percentage}
                handleChange={(e) =>
                  setTaxCatalogInfo({
                    ...taxCatalogInfo,
                    percentage: e.target.value,
                  })
                }
                type="number"
              />
            </div>
          </div>
          <div className="row nameDetails">
            <div className="col-1">
              <label className="textlabel">Location:</label>
            </div>
            <div style={{ width: '430px' }}>
              <Dropdown
                selected={centerId}
                updateDropdown={(option: any) => {
                  setCenterId(option);
                }}
                placeholder="Location"
                options={dropdownCenters}

              />
            </div>
          </div>


          <div className="button-alignment">
            <div>
              <Button
                text="Cancel"
                type={"button"}
                outline={true}
                onClick={() => onCancel()}
                id="cancel"
              />
            </div>
            <div>
              <Button text="Save" type="submit" id="save" />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}
export default AddNewTax
